var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUnhappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.8333 62.333C92.5277 62.333 96.3333 58.5274 96.3333 53.833C96.3333 49.1386 92.5277 45.333 87.8333 45.333C83.1389 45.333 79.3333 49.1386 79.3333 53.833C79.3333 58.5274 83.1389 62.333 87.8333 62.333Z",
    fill: "#A2021F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1666 62.333C52.861 62.333 56.6666 58.5274 56.6666 53.833C56.6666 49.1386 52.861 45.333 48.1666 45.333C43.4722 45.333 39.6666 49.1386 39.6666 53.833C39.6666 58.5274 43.4722 62.333 48.1666 62.333Z",
    fill: "#A2021F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9434 11.333C36.6634 11.333 11.3334 36.7197 11.3334 67.9997C11.3334 99.2797 36.6634 124.666 67.9434 124.666C99.28 124.666 124.667 99.2797 124.667 67.9997C124.667 36.7197 99.28 11.333 67.9434 11.333ZM68 113.333C42.9534 113.333 22.6667 93.0463 22.6667 67.9997C22.6667 42.953 42.9534 22.6663 68 22.6663C93.0467 22.6663 113.333 42.953 113.333 67.9997C113.333 93.0463 93.0467 113.333 68 113.333ZM38.9867 99.1663C43.52 87.5497 54.7967 79.333 68 79.333C81.2034 79.333 92.48 87.5497 97.0134 99.1663H87.55C83.5834 92.423 76.3867 87.833 68 87.833C59.6134 87.833 52.36 92.423 48.45 99.1663H38.9867Z",
    fill: "#A2021F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnhappy);
export default __webpack_public_path__ + "static/media/ic-unhappy.c3e3d049.svg";
export { ForwardRef as ReactComponent };